/* src/app/features/contratacao/operacao-repasse-bndes/operacao-repasse-bndes-cadastro/operacao-repasse-bndes-cadastro.component.scss */
.btn-clear {
  top: 50%;
  right: 0.5rem;
  transform: translateY(-50%);
  z-index: 2;
  font-size: small;
}
.btn-clear:focus {
  outline: none !important;
  box-shadow: none !important;
  border: none;
}
/*# sourceMappingURL=operacao-repasse-bndes-cadastro.component.css.map */
